import { Auth } from '@scouts/auth'

import { PATH_LOGIN, PATH_RESET_PASSWORD } from '@/constants'

export const SetPassword = () => {
    return (
        <Auth.LockscreenLayout title="Establece tu contraseña" footer={null}>
            <Auth.SetPasswordForm resetPasswordPath={PATH_RESET_PASSWORD} loginPath={PATH_LOGIN} />
        </Auth.LockscreenLayout>
    )
}
